import { gql } from 'graphql-tag'
import fragmentEventSpeaker from '../event-speaker/fragment-event-speaker.js'

export default gql`
  ${fragmentEventSpeaker}
  fragment EventBlockSpeakersFragment on EventBlockSpeakers {
    sys {
      id
    }
    contentType: __typename
    title
    blockSpeakersDescription: description {
      json
    }
    eventSpeakersCollection {
      items {
        ...EventSpeakerFragment
      }
    }
  }
`
